import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { convertImage } from 'appSrc/utils/random';
import AspectRatio from 'react-aspect-ratio';
import TextTruncate from 'react-text-truncate';
import style from './styles/style.module.css';


class UserCarouselCard extends PureComponent {
    render() {
        const { user } = this.props;
        let profession = user.profession;

        if( profession && profession.title ) {
            profession = profession.title;
        }

        return (
            <div className={ `${ style.userCarouselCard } ${ this.props.className }` }
            style={ { ...this.props.style } }>
                <div className={ style.cardContent }>
                    <Link to={ '/' + user.slug }
                    className={ style.linkOverlay }
                    title={ user.displayName }></Link>

                    <Link to={ '/' + user.slug }
                    className={ style.userImage }
                    title={ user.displayName }>
                        <AspectRatio ratio='1/1'>
                            <div className={ style.imageWrapper } >
                                <img src={ convertImage( user.avatar, '/276x276' ) } alt='user image' />
                            </div>
                        </AspectRatio>
                    </Link>
                    <div className={ style.expandedCard }>
                        <div className={ style.associatedDetails }>
                            <TextTruncate className={ `${ style.detail } ${ style.profession }` }
                            line={ 2 }
                            text={ profession } />
                            <TextTruncate className={ `${ style.detail } ${ style.userTitle }` }
                            line={ 2 }
                            text={ user.displayName } />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
UserCarouselCard.defaultProps = {
    user: {},
    className: '',
};
UserCarouselCard.propTypes = {
    user: PropTypes.object.isRequired,
};

export default UserCarouselCard;
